import { isNativePlatform } from "./platformFeatures";

function storageForSensitiveData() {
  if (typeof window === "undefined") return null;
  return isNativePlatform() ? window.localStorage : window.sessionStorage;
}

export function readSensitiveItem(key) {
  if (!key) return null;
  try {
    const storage = storageForSensitiveData();
    const current = storage?.getItem(key) ?? null;
    if (current !== null || isNativePlatform()) return current;

    // Web gecisi: eski kalici cache'i ayni sekme oturumuna bir kez tasi.
    const legacy = window.localStorage?.getItem(key) ?? null;
    if (legacy !== null) {
      window.sessionStorage?.setItem(key, legacy);
      window.localStorage?.removeItem(key);
    }
    return legacy;
  } catch {
    return null;
  }
}

export function writeSensitiveItem(key, value) {
  if (!key) return;
  try {
    storageForSensitiveData()?.setItem(key, String(value));
    if (!isNativePlatform()) window.localStorage?.removeItem(key);
  } catch {}
}

export function removeSensitiveItem(key) {
  if (!key) return;
  try { window.localStorage?.removeItem(key); } catch {}
  try { window.sessionStorage?.removeItem(key); } catch {}
}
